// extracted by mini-css-extract-plugin
module.exports = {"MWChip":"MWChip_MWChip__38vBo","MWChipActive":"MWChip_MWChipActive__3tjFc"};